import Vue from "vue";
import Vuex from "vuex";
import { Toast } from "vant";

/**
 * 各个模块
 */
import user from "./modules/user";

/**
 * 全局状态管理
 */
const state = {
  routeIsBack: false,
  progress_active: "0",
  progress_actives: "1",
  progress_scroll: 0,
  recommend_id: "",
  projectCode: "",
  projectName: "",
  projectScroll: 0,
  checkedBg: 1,
  project_code: "",
  city: "",
  project: "",
  isLoading: false,
};
const actions = {
  /**
   * 显示提示 msg.type 类型  msg.data 消息内容
   * @param commit
   * @param msg
   */
  showMassage({ commit }, msg) {
    console.log(msg);
    Toast({
      type: msg.type,
      message: msg.message,
    });
  },
};
const mutations = {
  /**
   * 更改路由前进后退状态
   * @param state
   * @param boolean
   * @constructor
   */
  UPDATE_ROUTER_IS_BACK(state, boolean) {
    state.routeIsBack = !!boolean;
  },
  UPDATE_PROGRESS_ACTIVE(state, p) {
    state.progress_active = p.active;
    state.progress_actives = p.actives;
    state.progress_scroll = p.scroll;
  },
  SAVE_RECOMMEND_ID(state, p) {
    state.recommend_id = p.recommend_id;
  },
  //保存项目名称和code
  SAVE_PROJECT(state, p) {
    state.projectCode = p.projectCode;
    state.projectName = p.project;
  },
  //保存项目名称和code
  SAVE_PROJECTSCROLL(state, p) {
    state.projectScroll = p.projectScroll;
    state.checkedBg = p.checkedBg;
    state.project_code = p.projectCode;
    state.city = p.city;
    state.project = p.project;
  },
  // 下边两个不加跳转页面总会报错
  OPEN_LOADING(state) {
    state.isLoading = true;
  },
  CLOSE_LOADING(state) {
    state.isLoading = false;
  },
};
const getters = {};

Vue.use(Vuex);
export default new Vuex.Store({
  state,
  getters,
  actions,
  mutations,
  modules: {
    user,
  },
});
